import React, { useContext, useState } from 'react';

import { ApiRoutes, FetchContext, HttpMethods, ToastContext } from '../../contexts';

import { useAggregatedState } from '../../../helpers';

export const UtenteContext = React.createContext(null);

const { Provider } = UtenteContext;

export const UtenteProvider = (props) => {
    const {
        showWarningMessage,
        showSuccessMessage,
        showErrorMessage
    } = useContext(ToastContext);
    const { fetchOk, fetchAuthorized } = useContext(FetchContext);
    const [state, setState] = useAggregatedState({
        utente: null,
        ruoli: null,
        ruoliOptions: [],
        tipi: null,
    });

    const { utente } = state;

    const [isLoadingUtente, setIsLoadingUtente] = useState(false);
    const getUtenteAsync = async (utenteId) => {
        try {
            setIsLoadingUtente(true);
            const r = await fetchAuthorized(ApiRoutes.Utente.GetUtente({ utenteId }), {
                method: HttpMethods.GET
            });
            const result = await r.json();
            result.inizioValidita = new Date(result.inizioValidita);
            result.fineValidita = result.fineValidita ? new Date(result.fineValidita) : null;
            setState({ utente: result });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingUtente(false);
        }
    }

    const [isUpdatingUtente, setIsUpdatingUtente] = useState(false);
    const updateUtenteAsync = async (utenteId, utente) => {
        try {
            setIsUpdatingUtente(true);
            const r = await fetchAuthorized(ApiRoutes.Utente.UpdateUtente({ utenteId }), {
                method: HttpMethods.POST,
                body: JSON.stringify(utente),
            });
            const result = await r.json();
            setState({
                utente: {
                    ...result,
                    inizioValidita: new Date(result.inizioValidita),
                    fineValidita: result.fineValidita ? new Date(result.fineValidita) : null
                }
            });
            showSuccessMessage("Utente aggiornato");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsUpdatingUtente(false);
        }
    }

    const [isAddingUtente, setIsAddingUtente] = useState(false);
    const addUtenteAsync = async (utente) => {
        try {
            setIsAddingUtente(true);
            const r = await fetchAuthorized(ApiRoutes.Utente.AddUtente(), {
                method: HttpMethods.PUT,
                body: JSON.stringify(utente),
            });
            const result = await r.json();
            setState({
                utente: {
                    ...result,
                    inizioValidita: new Date(result.inizioValidita),
                    fineValidita: result.fineValidita ? new Date(result.fineValidita) : null
                }
            });
            showSuccessMessage("Utente creato");
            window.close();
        } catch (e) {
            console.debug(e);
        } finally {
            setIsAddingUtente(false);
        }
    }

    const [isLoadingRuoli, setIsLoadingRuoli] = useState(false);
    const getRuoliAsync = async (pageIndex = 0, pageSize = 100) => {
        try {
            setIsLoadingRuoli(true);
            const r = await fetchAuthorized(ApiRoutes.Ruolo.GetRuoli({ pageIndex, pageSize }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => {
                return {
                    ...e,
                    inizioValidita: new Date(e.inizioValidita),
                    fineValidita: e.fineValidita ? new Date(e.fineValidita) : null,
                }
            });
            setState({
                ruoli: list, ruoliOptions: list.result.map(e => {
                    return { ruoloId: e.id, label: `${e.nome}` }
                }).sort((a, b) => a.label.localeCompare(b.label))
            });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingRuoli(false);
        }
    }

    const [isLoadingTipi, setIsLoadingTipi] = useState(false);
    const getTipiAsync = async (pageIndex = 0, pageSize = 100, padreId = null) => {
        try {
            setIsLoadingTipi(true);
            const r = await fetchAuthorized(ApiRoutes.TipoUfficio.GetTipiUffici({ pageIndex, pageSize, padreId }), {
                method: HttpMethods.GET
            });
            const list = await r.json();
            list.result = list.result.map(e => {
                return {
                    ...e,
                    inizioValidita: new Date(e.inizioValidita),
                    fineValidita: e.fineValidita ? new Date(e.fineValidita) : null,
                }
            });
            setState({ tipi: list });
        } catch (e) {
            console.debug(e);
        } finally {
            setIsLoadingTipi(false);
        }
    }

    return (
        <Provider value={{
            isLoadingUtente,
            getUtenteAsync,

            isUpdatingUtente,
            updateUtenteAsync,

            isAddingUtente,
            addUtenteAsync,

            isLoadingRuoli,
            getRuoliAsync,

            isLoadingTipi,
            getTipiAsync,

            setState,
            state,
        }}>
            {props.children}
        </Provider>
    );
}